export default "__VITE_ASSET__F9eaJ$Yk__"